// Module API users centralisé, cohérent avec le reste de l'API

import type { User, UserUpdatePayload } from '@/types/user'
import { apiDelete, apiGet, apiPost, apiPut } from './http'

export const users = {
  async getAll(): Promise<User[]> {
    const res = await apiGet<any>('/users')
    // Accepte un tableau brut OU un objet { success, data }
    if (Array.isArray(res)) return res
    if (res && Array.isArray(res.data)) return res.data
    throw new Error('Erreur chargement utilisateurs')
  },

  async update(id: number, data: UserUpdatePayload): Promise<User> {
    const res = await apiPut<any>(`/users/${id}`, data)
    if (res && res.data) return res.data
    return res
  },

  async resetPassword(email: string) {
    const res = await apiPost<any>('/auth/forgot-password', { email })
    if (res && res.data) return res.data
    return res
  },

  async toggleStatus(id: number, isActive: boolean) {
    const res = await apiPut<any>(`/users/${id}`, { isActive })
    if (res && res.data) return res.data
    return res
  },

  async hardDelete(id: number) {
    const res = await apiDelete<any>(`/users/${id}`)
    if (res && res.data) return res.data
    return res
  },
}
